import { lowerFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { QuoteEntityType } from 'quotes/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  entityType: QuoteEntityType;
  archive: boolean;
}

export const ArchiveConfirmation = ({
  isOpen,
  onConfirm,
  onCancel,
  entityType,
  archive = true,
}: IProps) => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  const titleKey = archive ? 'titleArchiveQuote' : 'titleRestoreQuote';

  const confirmationMessageKey = archive
    ? 'messageConfirmArchiveQuote'
    : 'messageConfirmRestoreQuote';

  const buttonLabel = archive ? t('buttonLabelArchive') : t('buttonLabelRestore');

  return (
    <Confirmation
      isOpen={isOpen}
      title={t(titleKey, { count: selectedRows?.length, entityType })}
      message={t(confirmationMessageKey, {
        count: selectedRows?.length,
        entityType: lowerFirst(entityType),
      })}
      confirmBtnLabel={buttonLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
